import { createMuiTheme, ThemeOptions } from '@material-ui/core';
import { PaletteOptions } from '@material-ui/core/styles/createPalette';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';
import { Overrides } from '@material-ui/core/styles/overrides';
import shadows, { Shadows } from '@material-ui/core/styles/shadows';

const palette: PaletteOptions = {
  primary: { // green (success)
    main: 'rgba(104, 203, 66, 1.0)',
    light: 'rgba(104, 203, 66, 0.6)',
    dark: 'rgba(38, 124, 6, 1.0)',
  },
  secondary: { // red (error)
    main: 'rgba(200 , 30, 30, 1.0)',
    light: 'rgba(200 , 30, 30, 0.5)',
    dark: 'rgba(150, 20, 20, 1.0)',
  },
  text: {
    primary: 'rgba(104, 203, 66, 1.0)',
  },
};

const typography: TypographyOptions = {
  fontFamily: [
    'Roboto',
    'sans-serif',
  ].join(','),
  fontSize: 12,
};

const overrides: Overrides = {
  MuiCssBaseline: {
    '@global': {
      html: {
        WebkitFontSmoothing: 'auto',
      },
    },
  },
};

export const statusTextTheme: ThemeOptions = createMuiTheme({
  palette,
  typography,
  overrides,
  shadows: shadows.map(() => 'none') as Shadows,
});
